import React, { FC } from 'react';
import { Button, IButtonProps } from '@hox/ui/Button';
import styled from 'styled-components';
import { TinyLoadingIndicator } from 'components/TinyLoadingIndicator';
import { MagicLinkSvg } from './MagicLinkSvg';

interface ISendMagicLinkButtonProps extends IButtonProps {
  loading: boolean;
  onClick?: () => void;
}

const MagicLinkButton = styled(Button)`
  display: inline-flex;
  justify-content: center;
  align-items: center;
`;

const MagicLinkIcon = styled(MagicLinkSvg)`
  display: block;
  margin: 0;
  margin-right: 1rem;
`;

const LoadingIndicator = styled(TinyLoadingIndicator)`
  margin: 0.25rem; /* Prevent button height change when loading */
`;

const SendMagicLoginLinkButton: FC<ISendMagicLinkButtonProps> = ({
  children,
  onClick,
  loading,
  ...restProps
}) => {
  return (
    <MagicLinkButton
      onClick={() => {
        if (!onClick || loading) {
          return;
        }
        onClick();
      }}
      {...restProps}
    >
      {loading ? (
        <LoadingIndicator />
      ) : (
        <>
          <MagicLinkIcon />
          {children}
        </>
      )}
    </MagicLinkButton>
  );
};

export { SendMagicLoginLinkButton };
